var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5743_1522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 15.9229C32.0002 7.12886 24.8712 -7.43866e-05 16.0772 -7.43866e-05C7.28323 -7.43866e-05 0.154297 7.12886 0.154297 15.9229C0.154297 23.8704 5.97708 30.4578 13.5893 31.6523V20.5256H9.54634V15.9229H13.5893V12.4148C13.5893 8.42415 15.9664 6.21982 19.6036 6.21982C21.3457 6.21982 23.1679 6.53081 23.1679 6.53081V10.4493H21.1601C19.182 10.4493 18.5652 11.6767 18.5652 12.936V15.9229H22.9813L22.2753 20.5256H18.5652V31.6523C26.1774 30.4578 32.0002 23.8704 32.0002 15.9229Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5743_1522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cd0a665108fc8d4321ac7f6dfd5e915d.svg";
export { ForwardRef as ReactComponent };